/* eslint-disable no-shadow */
import { Point } from '../geom/Point';
import { AbstractInput } from './AbstractInput';
import { Modifiers } from './Modifiers';

export enum MouseButtons {
    None = -1,
    Main = 0,
    Auxiliary = 1,
    Secondary = 2,
    Fourth = 3,
    Fifth = 4,
}

export class MouseInput extends AbstractInput {

    public static computePosition(e: MouseEvent, relativeElmt: HTMLElement) {
        return Point.from(e, 'client').subtract(relativeElmt.getBoundingClientRect());
    }

    public constructor(
        public readonly button: MouseButtons,
        public readonly modifiers: Modifiers,
        public readonly position: Point,
        public readonly count: number,
        public readonly targets: any[],
    ) {
        super(modifiers, targets);
    }
}
